import { z } from 'zod'
import { agentV2Request } from '@/agent-v2/conversations/fetch/agent-v2-request'
import { kAgentV2RouterApiBasePath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { ApiResponsePayloadError } from '@/util/errors/api-response-payload-error'

const ResearchContactResponseSchema = z.object({ sent: z.literal(true) })

export async function postResearchContact(turnId: string): Promise<void> {
  await agentV2Request({
    url: `${kPaxtonAppApiRESTBaseUrl()}${kAgentV2RouterApiBasePath}/turns/${encodeURIComponent(turnId)}/research-contact`,
    method: 'POST',
    sentryEndpoint: 'POST /api/v2/agent/turns/{turn_id}/research-contact',
    sentryExtra: { turnId },
    parseResponse: (data, { response }) => {
      const parsed = ResearchContactResponseSchema.safeParse(data)
      if (!parsed.success) throw new ApiResponsePayloadError(response.status, 'Invalid research contact response', parsed.error.issues)
      return parsed.data
    },
  })
}
